import { License } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import {
  TXTWCL_Chests_are_awarded_as_part_of__ELL,
  TXTWCL_Chests_are_awarded_from_the_St_ELL,
  TXTWCL_Chests_are_awarded_from_the_St_ELL_1
} from './ChestAwardMessage.messages.json';

const ChestAwardMessage: React.FC = () => {
  const license = useSelector(select.account.getLicense);

  switch (license) {
    case License.BG:
    case License.ES:
      return <Translation {...TXTWCL_Chests_are_awarded_from_the_St_ELL_1} />;
    case License.SE:
      return <Translation {...TXTWCL_Chests_are_awarded_as_part_of__ELL} />;
    default:
      return <Translation {...TXTWCL_Chests_are_awarded_from_the_St_ELL} />;
  }
};

export default ChestAwardMessage;
